<template>
  <div>
    <div class="columns">
      <div
        v-if="data.topic === 'nationality'"
        class="column"
      >
        <b-field
          id="nationality"
          class="kyc-nationality-is-expanded"
        >
          <b-autocomplete
            v-validate="{ required: true, isNationalityNotAvailable: countries, isNationality: countries }"
            v-model="nationalityInput"
            :data="filteredContries"
            :placeholder="$t('kyc.nationality')"
            field="nationality"
            name="nationality"
            autocomplete="disabled"
            open-on-focus
            data-test="edit-kyc-nationality--nationality-field"
            @select="selectNationality"
          >
            <template slot-scope="props">
              <div :class="[{ 'disabled-country': props.option && props.option.hasOwnProperty('disabled') && props.option.disabled }]">
                {{ `${props.option.nationality} ${props.option.hasOwnProperty('disabled') && props.option.disabled ? '(not available)' : ''}` }}
              </div>
            </template>
            <template slot="empty">{{ $t('messages.no_result_found') }}</template>
          </b-autocomplete>
        </b-field>
        <span class="is-invalid">{{ errors.first('nationality') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nationality',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    countries: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      nationalityInput: ''
    }
  },
  computed: {
    filteredContries () {
      if (this.nationalityInput) {
        return this.countries.filter((option) => {
          return option.nationality.toString().toLowerCase().indexOf(this.nationalityInput.toLowerCase()) >= 0
        })
      }
      return this.countries
    }
  },
  watch: {
    nationalityInput (value) {
      if (this.countries.length) {
        const expectedCountry = this.countries.length && this.countries.find(c => c.nationality.toLowerCase() === value.toLowerCase())
        if (expectedCountry && (!expectedCountry.hasOwnProperty('disabled') || (expectedCountry.hasOwnProperty('disabled') && !expectedCountry.disabled))) {
          this.form.nationality = value
        } else {
          this.form.nationality = ''
        }
      }
    }
  },
  async created () {
    if (this.form.nationality) {
      this.nationalityInput = this.form.nationality
    }
  },
  methods: {
    selectNationality (option) {
      if (option) {
        this.form.nationality = option.nationality
      } else {
        this.form.nationality = ''
      }
    }
  }
}
</script>

<style lang="scss">
.kyc-nationality-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.disabled-country {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/pages/SummaryOfKYC/components/Nationality.vue